__turbopack_context__.v({
  "postFullTag": "view-module__Lh6XTq__postFullTag",
  "postFullTagParagraph": "view-module__Lh6XTq__postFullTagParagraph",
});
